import { render, staticRenderFns } from "./AdminEmployee.vue?vue&type=template&id=ddf15a58&"
import script from "./AdminEmployee.vue?vue&type=script&lang=js&"
export * from "./AdminEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports